module.exports = __webpack_public_path__ + "static/media/RewardsIcon.65f90d5d.svg";